import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { KRollService } from 'src/app/core/services/api-services/kroll.service';

@Component({
  selector: 'app-remove-ac-applied-modal',
  templateUrl: './remove-ac-applied-modal.component.html',
  styleUrls: ['./remove-ac-applied-modal.component.scss'],
})
export class RemoveAcAppliedModal implements OnInit {
  editMode = false;
  note_id: any;
  noteForm!: FormGroup;
  isLoading = false;
  title: any;
  minDate = new Date();
  constructor(
    public dialogRef: MatDialogRef<RemoveAcAppliedModal>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private krollService: KRollService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {

    if (this.data['rowData']) {
      this.editMode = true;
      this.getPlanById(this.data['rowData']);
    }

    this.initializeNote();
  }

  initializeNote() {
    this.noteForm = this.fb.group({
      id: new FormControl(this.data.rowData.ID, [Validators.required]),
      order_id: new FormControl(this.data.rowData.OrderID, [Validators.required]),
    });
  }

  submitForm() {
    const payload = this.noteForm.value;
    this.isLoading = true;
      this.krollService.removeAdditionalCoverage(payload).subscribe(
        (res: any) => {
          if (res && res['body']['success']) {
            this.isLoading = false;
            this.toastr.success(res.body.message);
            this.dialogRef.close(true);
          } else {
            this.isLoading = false;
            this.toastr.error(res.body.message);
          }
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }

  getPlanById(data: any) {
    this.title = data.OrderID
  }
}
